<template>
  <div v-rect-loading="loading" class="account-container">
    <div class="account-editor-header">
      <div class="account-editor-title">{{ $t(`${i18nPrefix}.title`) }}</div>
    </div>
    <div class="account-info-container">
      <WrappedFrom
        ref="form"
        class="account-info"
        labelPosition="left"
        :label-width="isEn() ? '135px' : '100px'"
        :model="accountInfo"
        :formLines="formLines"
      ></WrappedFrom>
      <div>
        <p>{{ $t(`${i18nPrefix}.label.note`) }}</p>
        <p>{{ $t(`${i18nPrefix}.label.note1`) }}</p>
        <p>{{ $t(`${i18nPrefix}.label.note2`) }}</p>
      </div>
      <div class="bottom-btn-group">
        <el-button class="save-btn" type="primary" @click="handleSave">{{$t('common.btn.save')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { isEn } from '@/i18n'
import WrappedFrom from '@/components/formEditor/wrappedForm.vue'

export default {
  components: {
    WrappedFrom
  },
  data () {
    return {
      i18nPrefix: 'admin.company.serviceAccountManagement',
      loading: false,
      isEn,
      accountInfo: {
        roleNameType: 'HQ_ADMIN',
        emailAddress: null,
        companyId: null
      }
    }
  },
  computed: {
    formLines () {
      const lines = {
        roleNameType: {
          elType: 'el-select',
          label: this.$t(`${this.i18nPrefix}.label.adminType`),
          option: {
            data: [
              { value: 'HQ_ADMIN', label: this.$t(`${this.i18nPrefix}.label.hQAdmin`) },
              { value: 'AJINGA_SYSTEM_ADMIN', label: this.$t(`${this.i18nPrefix}.label.ajingaSystemAdmin`) }
            ]
          }
        },
        emailAddress: {
          label: this.$t(`${this.i18nPrefix}.label.emailAddress`),
          placeholder: this.$t(`${this.i18nPrefix}.label.emailAddress`),
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }],
          props: { type: 'email' }
        },
        companyId: {
          label: this.$t(`${this.i18nPrefix}.label.companyId`),
          placeholder: this.$t(`${this.i18nPrefix}.label.companyId`),
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }],
          props: { type: 'number' }
        }
      }

      return lines
    }
  },
  created () {
  },
  methods: {
    ...mapActions('userManagement', ['createServiceAccount']),
    async handleSave () {
      const result = await this.$refs.form.submit()
      if (!result) {
        return
      }

      this.loading = true
      try {
        const { roleNameType, emailAddress, companyId } = this.accountInfo
        const params = {
          role_name_type: roleNameType,
          email_address: emailAddress,
          company_id: companyId
        }
        await this.createServiceAccount(params)
        this.$message({
          type: 'success',
          message: this.$t(`${this.i18nPrefix}.message.createAdminSuccess`)
        })
        this.accountInfo.emailAddress = null
        this.accountInfo.companyId = null
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.account-container {
  .account-editor-header {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    .account-editor-title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }
  .account-info-container {
    width: 600px;
    margin: 30px auto 0;
    .bottom-btn-group {
      display: flex;
      justify-content: flex-end;
      margin: 30px auto 0;
      .el-button {
        padding: 8px 28px;
        border-radius: 2px;
        line-height: 22px;
        font-size: 16px;
        font-weight: 500;
        color: #0096cc;
        &:last-child {
          margin-left: 24px;
          margin-right: 0;
          background: #0096cc;
          border-color: #0096cc;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
